import React from 'react'
import Layout from '~layout'
// eslint-disable-next-line import/extensions
import * as Styled from '~styles/Textual.styles'

const TermsOfUsePage: React.FC = () => (
  <Layout>
    <Layout.Content isCompact>
      <Styled.Container>
        <Styled.Text>
          <Styled.Title>Website Terms of Use</Styled.Title>
          <Styled.Date>Last updated: Feb 14, 2025</Styled.Date>
          <Styled.ParagraphStrong>
            By using the Unbounded website, you agree to be bound by the following terms and conditions, which may be revised at our complete
            discretion and without notice to you. Use of Unbounded products and services is governed under the agreements between you and Unbounded
            for those products and services.
          </Styled.ParagraphStrong>
          <Styled.Paragraph>
            All products, technologies and processes described in this website are the subject of Unbounded’s intellectual property rights and nothing
            in the Unbounded websites is deemed to grant or imply a license to such rights.
          </Styled.Paragraph>
          <Styled.Paragraph>
            You may download, view, copy and print materials from the website subject to the following: (a) they may be used solely for personal,
            informational, non-commercial purposes; and (b) they may not be modified or altered in any way. Except where your use constitutes
            &quot;fair use&quot; under copyright law, you may not otherwise use, download, upload, copy, print, display, perform, reproduce, publish,
            license, post, transmit or distribute any information from Unbounded websites in whole or in part without the express authorization of
            Unbounded.
          </Styled.Paragraph>
          <Styled.Paragraph>
            Unbounded&apos;s website and the information made available by Unbounded through its websites is provided on an “as is” basis without
            warranty of any kind, either express or implied, including but not limited to, the implied warranties of merchantability, fitness for a
            particular purpose, or non-infringement. Unbounded makes no warranty that (a) the Unbounded websites will meet your requirements; (b) the
            websites will be available on an uninterrupted, timely, error-free basis; or (c) the results that may be obtained from the use of the
            websites will be accurate or reliable.
          </Styled.Paragraph>
          <Styled.Paragraph>
            Under no circumstances will Unbounded be liable to you or any third party for any direct, indirect, special, consequential, incidental or
            punitive damages caused from the use of the Unbounded websites, or on any other website linked from the Unbounded website, including,
            without limitation, any lost profits, business interruption, loss of programs or other data on your information handling system or
            otherwise, even if Unbounded is expressly advised of the possibility of such damages.
          </Styled.Paragraph>
          <Styled.Paragraph>Information on the website may be changed or updated without notice.</Styled.Paragraph>
          <Styled.Paragraph>
            The terms and conditions herein and all matters relating to your access to, and use of, Unbounded website shall be governed by the laws of
            the State of California.
          </Styled.Paragraph>
          <Styled.Address>
            © 2025{' '}
            <Styled.Link href="https://unbounded.network" target="_blank" rel="noopener">
              https://unbounded.network
            </Styled.Link>
          </Styled.Address>
          <Styled.Paragraph>All Rights Reserved.</Styled.Paragraph>
        </Styled.Text>
      </Styled.Container>
    </Layout.Content>
  </Layout>
)

export default TermsOfUsePage
